import { Text } from '@chakra-ui/react'

import { getUserUrl } from '@/client/services/url'
import { requiresChangesBeforeReview } from '@/client/services/volunteerActivity'

import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

import type { VolunteerActivityReviewer } from '../types'

export function ChangesRequestedBanner({
  reviewer,
  requestedChanges,
  requestedChangesAt,
  lastSubmittedAt,
}: {
  reviewer: VolunteerActivityReviewer
  requestedChanges: string | null
  requestedChangesAt: Date | null
  lastSubmittedAt: Date
}): JSX.Element | null {
  if (requestedChanges == null) {
    return null
  }

  const requiresChanges = requiresChangesBeforeReview({ requestedChangesAt, lastSubmittedAt })

  return (
    <Alert variant={requiresChanges ? 'warning' : 'success'}>
      <Text>
        {requiresChanges ? (
          reviewer.id == null ? (
            'The following changes have been requested before next review:'
          ) : (
            <>
              <ShwLink href={getUserUrl({ userId: reviewer.id, username: reviewer.username })}>
                {reviewer.displayName}
              </ShwLink>{' '}
              requested the following changes before next review:
            </>
          )
        ) : (
          'Has been updated since the following requested changes, and is ready for review:'
        )}{' '}
        <Text>{`"${requestedChanges}"`}</Text>
      </Text>
    </Alert>
  )
}
